import { ReactElement } from 'react';

import { Tooltip } from '@material-ui/core';

import { ButtonIcon } from '@backstage/ui';

type ToolbarButtonProps = {
  label: string;
  icon: ReactElement;
  onClick: () => void;
};

export const ToolbarButton = ({ label, icon, onClick }: ToolbarButtonProps) => (
  <Tooltip title={label}>
    <ButtonIcon
      aria-label={label}
      onClick={onClick}
      size="medium"
      icon={icon}
      variant="tertiary"
      data-track-id={`button.toolbar-${label.toLowerCase().replace(/\s+/g, '-')}`}
      data-track-action="update"
    />
  </Tooltip>
);
